// extracted by mini-css-extract-plugin
export default {"nav-item":"NavItem_nav-item__PiUfE","icon":"NavItem_icon__lyhjZ","rotate":"NavItem_rotate__iYVEj"};